import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h1>404!!!!!!! Not found</h1>
            <h3>Something went wrong,please try again.</h3>
        </div>
    );
};

export default NoMatch;